import Pusher from "pusher-js";

export const pusher = new Pusher('', {
  cluster: 'eu'
});
